<template>
  <div>
    <div class="dropzone">

      <div id="upload">

        <vxe-grid ref="xGrid" v-bind="gridOptions" @edit-disabled="editDisabledEvent" @cell-dblclick="noEdit"
          @checkbox-change="checkboxChangeEvent" @checkbox-all="checkboxChangeEvent">
          <template #tools>
            <div style="display: flex;gap: 10px;">

              <el-dropdown trigger="click">
                <el-button class="btn btn1" icon="el-icon-circle-plus-outline" :disabled="getAddBtn()">{{
                  $t("message.button.add") }}</el-button>
                <el-dropdown-menu slot="dropdown">
                  <UploadList @handleFileSelect="handleFileSelect" />
                </el-dropdown-menu>
              </el-dropdown>

              <el-button class="btn btn2" icon="el-icon-delete" @click="removeAttachment" :disabled="getRemoveBtn()">{{
                $t("message.button.delete") }}</el-button>
              <el-button class="btn btn3" icon="el-icon-paperclip" style="margin-left: 0" @click="downloadAttachment"
                :disabled="!fileBtnPriv || xxPriv">{{
                  $t("message.button.download") }}</el-button>

              <el-button class="btn btn4" icon="el-icon-reading" style="margin-left: 0" @click="previewFile"
                :disabled="!fileReadBtnPriv">
                {{ $t("message.button.preview") }}
              </el-button>
              <el-button class="btn btn5" icon="el-icon-reading" @click="preview3DFile" :disabled="!fileReadBtnPriv"
                v-if="autoview">
                3D{{ $t("message.button.preview") }}
              </el-button>


              <div class="edit-table" style="margin-left: auto;">
                <el-button class="btn btn7" icon="el-icon-document-checked" @click="saveValue"
                  :disabled="!addBtnPriv || !addBtn || xxPriv">{{ $t("message.button.save") }}
                </el-button>
                <el-button class="btn btn8" icon="el-icon-circle-close" @click="cancelSave"
                  :disabled="!addBtnPriv || !addBtn || xxPriv">{{ $t("message.button.cancel") }}
                </el-button>
              </div>
            </div>
          </template>
          <template #bottom>
            <Bottom-Tips :data="{ selectRecords: selectRecords.length, totalRecords }">
              <span class="text">{{ $t('message.title.emptyTextInAttachment') }}</span>
            </Bottom-Tips>

          </template>
          <template #empty>
            <el-popover placement="top" trigger="click">
              <UploadList @handleFileSelect="handleFileSelect" />
              <empty slot="reference" :class="{ noneClick: getAddBtn() }" />
            </el-popover>
          </template>
        </vxe-grid>
      </div>
    </div>

    <el-dialog v-if="cascaderShow" class="searchAddBomList" :title="$t('message.title.add')"
      :visible.sync="cascaderShow" @close="closeCascaderShow">
      <div style="height: 270px">
        <div style="margin: 60px auto; padding-left: 50px">
          <el-cascader v-model="cascaderValue" :options="cascaderList" :props="cascaderProps" :show-all-levels="true"
            size="small" ref="cascaderAddr" style="width: 75%"></el-cascader>
          <el-button size="small" type="primary" style="margin-left: 10px" @click="getCascadeValue">{{
            $t("message.button.affirm") }}</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="$t('message.tips.upLoad')" :visible.sync="upLoadDialog" width="30%" height="50%"
      :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-progress :text-inside="true" :stroke-width="16" :percentage="upLoadProgress" status="success"></el-progress>
    </el-dialog>

  </div>
</template>


<script>
import axios from "axios";
import { Base64 } from "js-base64";
import BottomTips from "@/components/bottomTips.vue";
import Empty from './empty.vue'
import UploadList from "./uploadLabelList.vue";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      autoview: false,
      dialogClosedUploadId: "",

      // contents:'',
      // showIframe:false,

      selectRecords: [],
      totalRecords: "",
      gridOptions: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "530",
        size: "small",

        columns: [
          {
            type: "checkbox",
            width: 50,
            fixed: null,
          },
        ],
        data: [],
        printConfig: {},

        toolbarConfig: {
          zoom: true,
          custom: true,
          print: true,
          slots: {
            buttons: "tools",
          },
        },

        editConfig: {
          trigger: "dblclick",
          mode: "row",
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        sortConfig: {
          trigger: "cell",
        },
      },
      cols: [], //表头
      editShow: false,

      //权限
      removeBtnPriv: false,
      fileBtnPriv: false,
      fileReadBtnPriv: false,
      addBtnPriv: false,
      btnIsAdmin: true, //是否为项目经理
      btnIsProjectAdmin: true, //是否为项目负责人
      isExecuter: true, //是否为执行者

      //btn业务逻辑
      addBtn: false,
      removeBtn: false,


      cascaderShow: false,
      cascaderValue: [],
      cascaderList: [],
      cascaderProps: {},

      upLoadProgress: 0,
      upLoadDialog: false, //上传

      dialogTableVisible: false

      // resURL:''
    };
  },

  components: { BottomTips, Empty, UploadList },
  methods: {

    handleFileSelect(event) {
      console.log(event);
      const { files } = event.target;
      for (const key in files) {
        if (Object.prototype.hasOwnProperty.call(files, key)) {
          const element = files[key];
          this.upLoad(element)
        }
      }

    },

    onClick() {
      this.dialogTableVisible = true;
    },

    handlefile(file) {

      if (file.isFile) {
        // 是文件执行上传操作
        //file.file() 方法用于读取文件内容
        file.file((f) => {
          // f才是最终的文件
          this.upLoad(f);
          // const text = document.createTextNode(f.name + '—');
          // dropzone.appendChild(text);
          return;
        });
      } else {
        const dirReader = file.createReader();
        dirReader.readEntries((entries) => {
          for (let i = 0; i < entries.length; i++) {
            this.handlefile(entries[i]);
          }
        });
      }
    },

    getReleaseType() {
      const { classId } = this.$route.query;
      const baseId = +classId.substring(0, 3)

      let releaseType = false;
      if (baseId === 301) {
        const { editByStatusType } = this.getPriv
        releaseType = !editByStatusType;
      }
      return releaseType
    },

    getAddBtn() {
      const releaseType = this.getReleaseType();
      return (
        !this.addBtnPriv || !this.addBtn || this.xxPriv || releaseType
      );
    },
    getRemoveBtn() {
      const releaseType = this.getReleaseType();

      return (
        !this.removeBtnPriv ||
        !this.removeBtn ||
        this.xxPriv ||
        releaseType
      );
    },
    handleClose(done) {
      //  
      this.$confirm(this.$t("message.tips.closeUpLoad"))
        .then((_) => {
          this.upLoadDialog = false;
        })
        .catch((_) => { });
    },
    checkboxChangeEvent({ records }) {
      const $grid = this.$refs.xGrid;
      this.selectRecords = records;
    },
    upLoad(file) {
      console.log(file);


      const fd = new FormData();
      const objInfo = {
        ...this.objectId,
        ...this.changeInfo,
        fileSize: file.size,
        fileName: file.name,
      };

      const { classId, subClassId, id, changeId, fileName } = objInfo;
      const path = window.sessionStorage.getItem("tenantName") + '/' + ([classId, subClassId, id, changeId, fileName].join('/'))
      fd.append("path", path);
      for (const key in objInfo) {
        const element = objInfo[key];
        fd.append(key, element)
      }

      axios.post("/swift-file/files/checkFileNameAndRev", fd).then(res => {
        const { url, code, fileName, message } = res.data.object;
        if (code === 200) {
          return this.updateFile(file, fd, url);
        }
        if (code === 501) {
          return this.overWriteConfirm({ fileName, file, fd, url })
        }
        this.$message.error(message);
        return
      })
    },

    overWriteConfirm({ fileName, file, fd, url }) {
      this.$confirm(
        this.$t("message.confirm.overwrite"),
        fileName,
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.updateFile(file, fd, url);
        })
    },

    updateFile(file, fd, url) {
      if (file.size == 0) {
        this.upLoadDialog = false; //当附件大小为0KB时，不显示进度条
      } else {
        this.upLoadDialog = true; //展示进度条
      }
      var reopt = {
        method: "PUT",
        url: url,
        withCredentials: false,
        headers: { "Content-Type": "application/octet-stream" },
        validateStatus: function (status) {
          return status >= 200;
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            var complete =
              ((progressEvent.loaded / progressEvent.total) * 100) | 0;
            for (let index = 0; index < 81; index++) {
              this.upLoadProgress = index;
            }
            if (complete >= 100) {
              this.upLoadDialog = false;
              this.upLoadProgress = 0; // 重新置0
            }
          }
        },
        maxRedirects: 0,
        data: file,
      };

      axios.request(reopt).then((res) => {
        if ((res.status = 200 && res.data == "")) {
          axios.post("/swift-file/files/uploadFileMetadata", fd).then(res => {
            // console.log(res);
            if (res.data.code == 200) {
              this.$message({
                message:
                  this.$t("message.title.attachment") +
                  file.name +
                  this.$t("message.success.upLoad"),
                type: "success",
              });
              this.getAttachments();
            }
          });
        } else {
          this.$message.error(this.$t("message.error.add"));
        }
      }).catch(function (err) {
        this.$message.error(this.$t("message.error.add"));
      });
    },
    removeAttachment() {
      // console.log("removeAttachment");
      var removeRow = this.$refs.xGrid.getCheckboxRecords();
      // console.log(removeRow);
      let deletedFilesId = [];

      if (removeRow.length == 0) {
        this.$message({
          message: this.$t("message.tips.dele_data"),
          type: "warning",
        });
      } else {
        this.$confirm(
          this.$t("message.confirm.deleteData"),
          this.$t("message.tips.tip"),
          {
            confirmButtonText: this.$t("message.button.affirm"),
            cancelButtonText: this.$t("message.button.cancel"),
            type: "warning",
          }
        ).then(() => {
          for (var i = 0; i < removeRow.length; i++) {
            deletedFilesId.push(removeRow[i].fileId);
          }
          axios.post("/swift-file/files/deleteFile", deletedFilesId).then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: "success",
              });
              // console.log(res);
              this.getAttachments();
            }
          }).catch(function (error) {
            console.log(error);
          });
        }).catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.tips.deleteCancel"),
          });
        });
      }
    },
    previewFile() {
      var previewFileRow = this.$refs.xGrid.getCheckboxRecords();

      if (previewFileRow.length == 0) {
        return false;
      } else if (previewFileRow.length > 1) {
        this.$message({
          message: this.$t("message.warning.choice"),
          type: "warning",
        });
      } else {
        // var getFile = {
        //   fileId: previewFileRow[0].fileId,
        //   type: 'preview',//preview 不在记录在历史tab，所以有些参数没传
        // };
        var getFile = {
          ...this.objectId,
          ...this.changeInfo,
          fileId: previewFileRow[0].fileId,
          fileName: previewFileRow[0][0],
          type: "preview", //新加的参数是给记录到历史tab里用
        };
        //console.log(session.obsVO);
        // ${ this.params(getFile) }

        axios.post(`swift-file/files/getFileDownloadUrl`, getFile).then((res) => {
          console.log(res);
          var path = res.data.object.path;
          var preLink = res.data.object.previewUrl;
          //console.log(path);
          var url = path;
          // console.log(url);
          // console.log(preLink);
          var iWidth = window.screen.width - window.screen.width / 3; //弹出窗口的宽度;
          var iHeight = window.screen.height; //弹出窗口的高度;
          var iTop = 50;
          var iLeft = (window.screen.width - iWidth) / 2;
          window.open(
            preLink +
            "/onlinePreview?url=" +
            encodeURIComponent(Base64.encode(url)),
            "_blank",
            "height=" +
            iHeight +
            ",width=" +
            iWidth +
            ",top=" +
            iTop +
            ",left=" +
            iLeft +
            ""
          );
        });

      }
    },
    //临时添加在内部测试，正式发布到生产环境需要修改window.open(）中的link
    preview3DFile() {
      var previewFileRow = this.$refs.xGrid.getCheckboxRecords();
      // console.log(previewFileRow);
      // var downloadFilesId = [];
      if (previewFileRow.length == 0) {
        return false;
      } else if (previewFileRow.length > 1) {
        this.$message({
          message: this.$t("message.warning.choice"),
          type: "warning",
        });
      } else {
        // var getFile = {
        //   fileId: previewFileRow[0].fileId,
        //   type: 'preview',//preview 不在记录在历史tab，所以有些参数没传
        // };
        var getFile = {
          ...this.objectId,
          ...this.changeInfo,
          fileId: previewFileRow[0].fileId,
          fileName: previewFileRow[0][0],
          type: "preview", //新加的参数是给记录到历史tab里用
        };
        //console.log(session.obsVO);

        axios.post(`swift-file/files/getFileDownloadUrl`, getFile).then((res) => {
          console.log(res);
          var path = res.data.object.path;
          var preLink = res.data.object.previewUrl;

          var iWidth = window.screen.width - window.screen.width / 3; //弹出窗口的宽度;
          var iHeight = window.screen.height; //弹出窗口的高度;
          var iTop = 50;
          var iLeft = (window.screen.width - iWidth) / 2;
          var isReadOnly = false;
          // console.log(this.resURL);
          // const url = this.resURL + '/Autovue/jnlp?fileUrl=';
          window.open(
            "/Autovue/jnlp?fileUrl=" +
            encodeURIComponent(path) +
            "&isReadOnly=" +
            isReadOnly,
            "_blank",
            "height=" + 1 + ",width=" + 1 + ",top=" + 1 + ",left=" + 1 + ""
          );
        });
      }
    },

    downloadAttachment() {
      let downloadRow = this.$refs.xGrid.getCheckboxRecords();
      var download_table = [];


      if (downloadRow.length == 0) {
        return false;
      } else {
        for (let i = 0; i < downloadRow.length; i++) {
          download_table.push(downloadRow[i].rowId);
        }
        //console.log(del_table);
        var objId = {
          ...this.objectId,
          subClassId: this.objectId.subClassId,
        };
        var changeId = this.changeInfo.changeId;

        var relationshipMapVo = {
          delIds: download_table,
          objectId: objId,
          changeId: changeId,
        };

        axios.post("swift-file/files/getFileDownloadUrlByFileIdList", relationshipMapVo).then((res) => {
          if (res.data.code == 200) {
            let files = res.data.object;
            for (let i = 0; i < files.length; i++) {
              const xhr = new XMLHttpRequest();
              xhr.open("GET", files[i].path, true);
              xhr.responseType = "blob";
              xhr.onload = () => {
                const url = window.URL.createObjectURL(xhr.response);
                const a = document.createElement("a");
                a.href = url;
                a.download = files[i].fileName;
                a.click();
                a.remove();
              };
              xhr.send();
            }
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    //拷贝downloadAttachment的代码，只是改了downloadRow，和getFile。fileId getFile。fileName
    clickRowDownloadAttachment(clickRow) {
      var downloadRow = clickRow;
      console.log(downloadRow);
      var downloadFilesId = [];
      if (downloadRow.length == 0) {
        return false;
      } else if (downloadRow.length > 1) {
        this.$message({
          message: this.$t("message.warning.choice"),
          type: "warning",
        });
      } else {
        var getFile = {
          id: downloadRow.itemId,
          classId: downloadRow.itemClassId,
          subClassId: downloadRow.itemSubClassId,

          ...this.changeInfo,
          fileId: downloadRow.fileId,
          fileName: downloadRow[0],
          type: "download", //新加的参数是给记录到历史tab里用
        };

        axios.post(`swift-file/files/getFileDownloadUrl`, getFile).then((res) => {
          console.log(res);
          const path = res.data.object.path;
          //console.log(path);
          fetch(path).then((res) => res.blob()).then((blob) => {
            // 将链接地址字符内容转变成blob地址
            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = downloadRow[0]; // 下载文件的名字
            document.body.appendChild(a);
            a.click();
          });
        });
      }
    },

    noEdit({ row, column, columnIndex }) {
      // let systemName = window.sessionStorage.getItem("systemName");
      // if(systemName.indexOf('奥斯汀') != -1){
      // console.log(row, columnIndex);
      // console.log(this.gridOptions.columns);
      let fileNameIndex = 1;
      for (let k = 0; k < this.gridOptions.columns.length; k++) {
        if (
          this.gridOptions.columns[k].attid == this.Constants.attachmentFileName
        ) {
          fileNameIndex = Number(this.gridOptions.columns[k].field) + 1;
        }
      }
      //console.log(fileNameIndex);
      // if (columnIndex == fileNameIndex && this.fileBtnPriv) {
      //   //console.log("downloadAttachment");
      //   this.clickRowDownloadAttachment(row);
      // }
      // };

      if (column.editRender?.cascaderType && this.editTable) {
        this.cascaderList = column.editRender.cascadeOptions;
        let m = row[[column.property]];
        if (column.editRender.props.multiple) {
          this.cascaderValue = m ? m.map((i) => {
            return this.getParentIdList(this.cascaderList, i);
          }) : "";
          this.cascaderProps.multiple = true;
        } else {
          this.cascaderProps.multiple = false;
          this.cascaderValue = m;
        }
        this.cascaderProps.checkStrictly = true;
        this.tempData = { row, column };
        this.cascaderShow = true;
        console.log(this.cascaderValue);
      }
    },
    saveValue() {
      // console.log("saveValue");
      var xGrid_ = this.$refs.xGrid;
      let updateRecords = this.$refs.xGrid.getUpdateRecords(); //获取修改的行
      // console.log(updateRecords);
      var updateFile = [];
      if (updateRecords.length !== 0) {
        //判断行内那些值有改动
        for (let i = 0; i < updateRecords.length; i++) {
          var num = xGrid_.getRowIndex(updateRecords[i]);
          // console.log(updateRecords[i]);
          // console.log(num);
          // console.log(this.cols);
          var cols_length = this.cols;
          for (let j = 0; j < cols_length.length; j++) {
            var updateNewData = xGrid_.isUpdateByRow(updateRecords[i], "" + j);
            if (updateNewData) {
              // console.log(cols_length[j]+"---------"+updateRecords[i][j]+"---------"+updateRecords[i].rowId);
              // var obj = {};
              // var quantity = cols_length[j];
              // obj.id = updateRecords[i].rowId;
              // obj[quantity] = updateRecords[i][j];
              // updateFile.push(obj);
              for (let k = 0; k < this.gridOptions.columns.length; k++) {
                var obj = {};
                if (cols_length[j] == this.gridOptions.columns[k].attid) {
                  var quantity = cols_length[j];
                  obj.id = updateRecords[i].rowId;
                  if (this.gridOptions.columns[k].editRender.props) {
                    //处理多选和单选
                    if (this.gridOptions.columns[k].editRender.props.multiple) {
                      obj[quantity] = updateRecords[i][j].join(";");
                    } else if (
                      this.gridOptions.columns[k].editRender.props.type ==
                      "datetime"
                    ) {
                      console.log(updateRecords[i][j]);
                      // obj[quantity] = updateRecords[i][j].format("yyyy-MM-ddThh:mm:ss");
                      obj[quantity] = this.format(
                        updateRecords[i][j],
                        "yyyy-MM-ddThh:mm:ss"
                      );
                      console.log(obj[quantity]);
                    } else {
                      if (updateRecords[i][j] == null) {
                        obj[quantity] = "";
                      } else {
                        obj[quantity] = updateRecords[i][j];
                      }
                    }
                  } else {
                    if (updateRecords[i][j] == null) {
                      obj[quantity] = "";
                    } else {
                      obj[quantity] = updateRecords[i][j];
                    }
                  }
                  updateFile.push(obj);
                }
              }
            }
          }
        }
        var updateFileData = {
          //post更改的值
          tableId: 201,
          objId: {
            ...this.objectId,
            version: this.version,
          },
          updateFile: updateFile,
        };
        // console.log(updateFileData);

        axios.post("/pmdm/items/updateTable", updateFileData).then(res => {
          //console.log(res);
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getAttachments();
            xGrid_.revertData();
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    cancelSave() {
      this.$refs.xGrid.revertData(); //清除所有保存，删除，添加记录
    },
    editDisabledEvent() { },
    getAttachments() {

      var obj_get = {
        ...this.objectId,
        ...this.changeInfo,
        tableId: 201,
      };

      axios.get(`/pmdm/items/loadTable${this.params(obj_get)}`).then((res) => {

        this.gridOptions.columns = this.getNewTableTitleData(res.data);
        this.rols_text = this.getNewTableContentData(res.data);
        //this.gridOptions.data = this.rols_text;
        this.$refs.xGrid.loadData(this.rols_text);
        this.totalRecords = res.data.object.table.totalRecords;
        this.cols = res.data.object.table.columnInfo.ids;
        this.selectRecords = [];
      });
      //调用方法显示tab上的*号
      this.$emit('refreshTab');
    },

    loadUserPriv() {
      this.hasCustomerPrivAPI().then((res) => {
        const { downLoadPriv, hasPriv, previewPriv, delPriv, fileAddPriv } =
          res.data.object;
        // console.log(res.data.object.hasPriv);
        // const hasPriv = res.data.object.hasPriv;
        // console.log(hasPriv);
        const isSuperAdmin = this.$store.state.isSuperAdmin || hasPriv;

        this.addBtnPriv = isSuperAdmin || fileAddPriv;
        this.removeBtnPriv = isSuperAdmin || delPriv;
        this.fileBtnPriv = isSuperAdmin || downLoadPriv;
        this.fileReadBtnPriv = isSuperAdmin || previewPriv;
      });
    },

    hasCustomerPrivAPI() {
      var obj_get = {
        ...this.objectId,
        ...this.changeInfo,
        tableId: 201,
      };
      // var loadTableUrl = `/pmdm/items/loadTable${this.params(obj_get)}`;
      return axios.get(
        `/pmdm/relationship/hasCustomerPriv${this.params(obj_get)}`
      );
    },
    testing() {
      const { changeInfoNum = "[{}]" } = this.$route.query;
      const arr = JSON.parse(changeInfoNum);
      this.addBtn = arr.length == 1;
      this.removeBtn = arr.length == 1;
    },

  },
  computed: {
    ...mapGetters({
      projectStatus: "projectWorkflow/getProjectInfo",
      getPriv: "projectWorkflow/getPriv",
      projectEcrInfo: 'projectWorkflow/getCreateEcrInfo'
    }),
    objectId() {
      return { ...this.$store.state.objectId }
    },

    changeInfo() {

      const obj = {
        changeId: 0,
        changeClassId: 0,
        changeSubClassId: 0,
      };

      const { classId } = this.$route.query;
      const baseId = classId.substring(0, 3)
      if (baseId === '101') {
        // return {}
        const {
          changeId = 0,
          changeClassId = 0,
          changeSubClassId = 0,
        } = this.$store.state.change_info;
        return { changeId, changeClassId, changeSubClassId }
      }
      return obj
    },

    xxPriv() {
      const { classId } = this.$route.query;
      const baseId = classId.substring(0, 3)
      if (baseId !== '301') {
        return false
      }
      const { editProject, isAdministrator, isExecuter, } = this.getPriv
      if (!editProject) {
        return true
      }
      return !(isAdministrator || isExecuter)
    },

    workflowStatusType() {
      return this.$store.state.changeWorkflowStatus;
    },
  },

  created() {
    const modules = window.sessionStorage
      .getItem("modules")
      .split(",")
      .map(Number);
    this.autoview = modules.includes(this.Constants.licenseAutoVue);
    this.testing();
    this.getAttachments();
    this.loadUserPriv();
  },
  mounted() {
    // this.setDrag();
    const dropzone = document.querySelector(".dropzone");
    dropzone.addEventListener("dragover", (event) => {
      event.target.classList.add("fileshover");
      event.preventDefault(); //阻止默认行为，允许放置
    });

    dropzone.addEventListener("drop", (event) => {
      if (this.getAddBtn()) {
        this.$message.error('请检查是否有此权限')
        event.preventDefault();
        return;
      }
      const dataTransferItemList = event.dataTransfer.items;
      for (const dataTransferItem of dataTransferItemList) {
        const file = dataTransferItem.webkitGetAsEntry();
        // console.log(file);
        this.handlefile(file);
      }
      event.preventDefault(); //阻止浏览器默认行为，不会自动打开文件管理页面
    });
  },
  props: ["changeValue"],
  watch: {

    changeValue: function (value) {
      // this.changeInfo = value;
      //console.log(value);
      this.getAttachments();
      this.loadUserPriv();
    },

  },
};
</script>


<style>
.dropzone {
  /* background: silver; */
}

.dropzone .filehover {
  background-color: cadetblue;
}

.searchAddBomList .el-dialog__body {
  padding: 0 20px 20px 20px !important;
}

.el-table th.gutter {
  display: table-cell !important;
}

.link_ {
  color: #4b92ff;
  cursor: pointer;
}

.link_:hover {
  color: #4b92ff;
  cursor: pointer;
  border-bottom: 1px solid #4b92ff;
}
</style>
<style scoped lang="scss">
.input-file {
  display: none;
}

.text {
  cursor: pointer;
}

.text:hover {
  color: #4b92ff;
}


.drag-upload-box {
  /* width: 200px;
  height: 130px; */
  width: 100%;
  height: 600px;
}

.available {
  position: relative;
  /* 必须设置相对定位 */
}

.drag-upload-box.available::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(64, 158, 255, 0.3);
  /* rgba(87, 98, 227, 0.5); */
  /* 设置蒙版颜色和透明度 */
  z-index: 1;
  /* 确保蒙版在元素上方 */
}

.drag-upload-box.available>* {
  /* 防止拖拽到 子元素导致触发 dragleave*/
  pointer-events: none;
}

.noneClick {
  pointer-events: none;

}

.drag-upload-box.guide>* {
  pointer-events: none;
}
</style>
